import React, { useRef, useEffect, useState,Suspense} from 'react';
import {
    Button,Spinner,Modal,ModalHeader,ModalBody
} from 'reactstrap';
import { FaCopy, FaPaste, FaTrash } from 'react-icons/fa';
import { User, Share2, Clipboard,Users} from 'lucide-react';
import {message} from "antd";

import ReactStrapDataTable from '../Pages/CustomDatatable/ReactStrapDataTable';
import * as XLSX from 'xlsx';


export const dateSorter = (columnName) => (a, b) => {
    if (a[columnName] === null || b[columnName] === null) {
        return 0; // Treat nulls as equal
    }
    const dateA = new Date(a[columnName]);
    const dateB = new Date(b[columnName]);
    return dateA - dateB;
};
export const stringSorter = (columnName) => (a, b) => {
    if (a[columnName] === null || b[columnName] === null) {
        return 0; // Treat nulls as equal
    }
    return a[columnName].localeCompare(b[columnName]);
};
export const dateTimeSort = (columnName) => (a, b) => {
    if (a[columnName] === null || b[columnName] === null) {
        return 0; // Treat nulls as equal
    }

    if (a[columnName] !== null && b[columnName] !== null) {
        const dateA = new Date(a[columnName]);
        const dateB = new Date(b[columnName]);

        return dateA - dateB;
    }
};
export const numberSort = (columnName) => (a, b) => {
    const valueA = getNumberValue(a, columnName);
    const valueB = getNumberValue(b, columnName);

    return valueA - valueB;
};
const getNumberValue = (obj, columnName) => {
    const value = obj[columnName];
    if (typeof value === 'number') {
        return value;
    } else if (typeof value === 'string') {
        const parsedValue = parseFloat(value.replace(/[^0-9.-]+/g, ''));
        return isNaN(parsedValue) ? 0 : parsedValue;
    }
    return 0;
};
export const firstDayOfMonth = () => {
    const date = new Date();
    date.setDate(1);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed
    const day = '01'; // The first day of the month
    return `${year}-${month}-${day}`;
};
export function formatDate(dateString) {
    // Check if dateString is null or undefined
    if (dateString === null || dateString === undefined) {
        return ''; // Return an empty string or any other default value
    }

    // Check if dateString contains time information
    const timeRegex = /\d{2}:\d{2}:\d{2}/;
    const hasTime = timeRegex.test(dateString);

    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed
    const day = date.getDate().toString().padStart(2, '0');

    if (hasTime) {
        const hour = date.getHours().toString().padStart(2, '0');
        const minute = date.getMinutes().toString().padStart(2, '0');
        const second = date.getSeconds().toString().padStart(2, '0');
        return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    } else {
        return `${year}-${month}-${day}`;
    }
}
export function formatDateWithTime(dateString,wantTime) {
    // Check if dateString is null or undefined
    if (dateString === null || dateString === undefined) {
        return ''; // Return an empty string or any other default value
    }

    // Check if dateString contains time information
    const timeRegex = /\d{2}:\d{2}:\d{2}/;
    const hasTime = timeRegex.test(dateString);

    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed
    const day = date.getDate().toString().padStart(2, '0');

    if (hasTime && wantTime) {
        const hour = date.getHours().toString().padStart(2, '0');
        const minute = date.getMinutes().toString().padStart(2, '0');
        const second = date.getSeconds().toString().padStart(2, '0');
        return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    } else {
        return `${year}-${month}-${day}`;
    }
}
export const formDataToObject = (formData) => {
    const object = {};
    formData.forEach((value, key) => {
        // Attempt to parse JSON strings
        try {
            object[key] = JSON.parse(value);
        } catch (e) {
            object[key] = value;
        }
    });
    return object;
};
export const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
};
export function getActionUserType(type){
    return type==="C" ? "Closeout Manager" : type==="R" ? "Responsible Manager" : type==="S" ? "Supervisor" : "User"
}
export const returnRoute = (route) => {
    let finalRoute = "";
    switch (route) {
        case "hazards":
            finalRoute = "hazard";
            break;
        case "incidentReport":
            finalRoute = "incidentreport";
            break;
        case "nonConformities":
            finalRoute = "nonconformity";
            break;
        case "improvementOpportunities":
            finalRoute = "improvement";
            break;
        case "complaints":
            finalRoute = "complaint";
            break;
        default:
            finalRoute = "incident";
    }
    return finalRoute;
};
export const returnInformRoute = (route) => {
    let finalRoute = "";
    switch (route) {
        case "informGsps":
            finalRoute = "gsp";
            break;
        case "informLod1s":
            finalRoute = "lod1";
            break;
        case "informRhpws":
            finalRoute = "rhpw";
            break;
        case "informRpmws":
            finalRoute = "rpmw";
            break;
        case "informTbts":
            finalRoute = "tbt";
            break;

        case "informTnts":
            finalRoute = "tnt";
            break;
        default:
            finalRoute = "inform";
    }
    return finalRoute;
};
export const AccessFilter = ({ accessFilter, handleAccessFilterChange }) => {
    const options = [
      { value: 'My', icon: User },
      { value: 'Shared', icon: Share2 },
      { value: 'Assigned', icon: Clipboard }
    ];
  
    return (
      <div className="d-flex">
        {options.map(({ value, icon: Icon }) => (
          <Button
            key={value}
            color={accessFilter === value ? 'primary' : 'secondary'}
            onClick={() => handleAccessFilterChange(value)}
            className="me-2 d-flex align-items-center"
          >
            <Icon size={18} className="me-2" />
            {value}
          </Button>
        ))}
      </div>
    );
};
export const AccessFilterAll = ({ accessFilter, handleAccessFilterChange }) => {

    const options = [
        { value: 'All', icon: Users },
        { value: 'My', icon: User },
        { value: 'Shared', icon: Share2 },
    ];

    return (
        <div className="d-flex">
            {options.map(({ value, icon: Icon }) => (
                <Button
                    key={value}
                    color={accessFilter === value ? 'primary' : 'secondary'}
                    onClick={() => handleAccessFilterChange(value)}
                    className="me-2 d-flex align-items-center"
                >
                    <Icon size={18} className="me-2" />
                    {value}
                </Button>
            ))}
        </div>
    );
};
export const ResponsiveTable = ({ data, columns }) => {
  const tableRef = useRef(null);
  const [scrollWidth, setScrollWidth] = useState('100%');

  const wrapperStyle = {
    width: '100%',
    overflowX: 'auto'
  };

  const scrollStyle = {
    width: '300%'
  };
  useEffect(() => {
    const updateScrollWidth = () => {
      if (tableRef.current) {
        const tableWidth = tableRef.current.getBoundingClientRect().width;
        const containerWidth = tableRef.current.parentElement.getBoundingClientRect().width;
        if (tableWidth > containerWidth) {
          setScrollWidth(`${(tableWidth / containerWidth) * 100}%`);
        } else {
          setScrollWidth('100%');
        }
      }
    };

    updateScrollWidth();
    window.addEventListener('resize', updateScrollWidth);

    return () => {
      window.removeEventListener('resize', updateScrollWidth);
    };
  }, [data, columns]);

  return (
    <div style={wrapperStyle}>
      <div style={scrollStyle}>
        <div ref={tableRef}>
          <ReactStrapDataTable
            dataSource={data ?? []}
            columns={columns}
            rowKey="id"
            scroll={{ x: true }}
          />
        </div>
      </div>
    </div>
  );
};
export const manageCURDAccess = (access) => {
    const result = {};
    for (const [key, value] of Object.entries(access)) {
        result[key] = value === 1;
    }
    return result;
};
// export const isImageFile = (fileName) => {
//     const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
//     const extension = fileName.split('.').pop().toLowerCase();
//     return imageExtensions.includes(extension);
// };
export const getCurrentDateString = () => {
    return new Date().toISOString().split('T')[0];
};

export const isImageFile = (fileName) => {
    return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(fileName);
};

export const renderAttachment = (file, index) => {


    const renderValue = (value) => {
        if (value === undefined || value === null) return 'N/A';
        if (typeof value === 'boolean') return value ? '✅' : '❌';
        return value;
    };

    if (isImageFile(file.fileName)) {
        return (
            <div className="mb-2">
                <p>Description: {renderValue(file.description)}</p>
                <img
                    src={file.fullPath}
                    alt={file.fileName}
                    style={{width: '50%', height: 'auto'}}
                    className="max-w-full h-auto mb-2"
                    crossOrigin="anonymous"
                />
                <hr/>
            </div>
        );
    } else {
        return (
            <div className="mb-2">
                <a href={file.fullPath} target="_blank" rel="noopener noreferrer">
                    {file.fileName}
                </a>
                <p>Description: {renderValue(file.description)}</p>
                <hr/>
            </div>
        );
    }
};
export const exportToExcel = (columns, data) => {
    // Create workbook and worksheet
    const workbook = XLSX.utils.book_new();

    // Transform data to match column headers
    const transformedData = data.map(item => {
        const row = {};
        columns.forEach(col => {
            // Handle nested objects and special renders
            if (col.render) {
                row[col.title] = col.render(item[col.dataIndex], item);
            } else if (typeof item[col.dataIndex] === 'boolean') {
                row[col.title] = item[col.dataIndex] ? 'Yes' : 'No';
            } else {
                row[col.title] = item[col.dataIndex];
            }
        });
        return row;
    });

    // Create worksheet from data
    const worksheet = XLSX.utils.json_to_sheet(transformedData);

    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

    // Generate Excel file
    const excelBuffer = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
    });

    // Create Blob and download
    const blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `export_${new Date().getTime()}.xlsx`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const ScopeCopyPaste = ({
                                   selectedItems,
                                   menuId,
                                   handleItemSelect,
                                   countries,
                                   businessUnits,
                                   projectClients,
                                   projects,
                                   sites,
                                   l3,
                                   menu,
                                   allCountries,
                                   allBusinessUnits,
                                   allProjectClients,
                                   allProjects,
                                   allSites,
                                   allL3,
                                   accessSystemAdmin,
                                   accessSuperAdminM,
                                   selectedUser,
                                   selectedPermissions,
                                   copiedScope,
                                   setCopiedScope
                               }) => {
    const copyScope = () => {
        const currentMenuItems = selectedItems[menuId] || {};
        const scopeData = {
            countries: currentMenuItems.countries || [],
            businessUnits: currentMenuItems.businessUnits || [],
            projectClients: currentMenuItems.projectClients || [],
            projects: currentMenuItems.projects || [],
            sites: currentMenuItems.sites || [],
            l3: currentMenuItems.l3 || []
        };

        setCopiedScope(scopeData);
        message.success("Scope Copied Successfully");
    };

    const validateAndTransformData = (field, data, availableOptions) => {
        if (!Array.isArray(data)) return [];

        return data.filter(item =>
            availableOptions.some(option => option.id === item.value)
        ).map(item => ({
            value: item.value,
            label: availableOptions.find(opt => opt.id === item.value)?.name
        }));
    };

    const clearScope = () => {
        setCopiedScope(null);
        message.success("Scope Cleared Successfully");
    };

    const pasteScope = () => {
        if (!copiedScope) return;

        try {
            const isSystemAdmin = menu?.name === "System Admin";
            const hasAdminAccess = (accessSystemAdmin || accessSuperAdminM) && selectedUser?.isMe;

            const availableCountries = (isSystemAdmin && hasAdminAccess) ||
            (countries.length === 0 && (accessSystemAdmin || accessSuperAdminM))
                ? allCountries
                : countries;

            const currentBUs = isSystemAdmin ? allBusinessUnits : businessUnits;
            const currentPCs = isSystemAdmin ? allProjectClients : projectClients;
            const currentProjects = isSystemAdmin ? allProjects : projects;
            const currentSites = isSystemAdmin ? allSites : sites;
            const currentL3 = isSystemAdmin ? allL3 : l3;

            const validScopes = {
                countries: validateAndTransformData('countries', copiedScope.countries, availableCountries),
                businessUnits: validateAndTransformData('businessUnits', copiedScope.businessUnits, currentBUs),
                projectClients: validateAndTransformData('projectClients', copiedScope.projectClients, currentPCs),
                projects: validateAndTransformData('projects', copiedScope.projects, currentProjects),
                sites: validateAndTransformData('sites', copiedScope.sites, currentSites),
                l3: validateAndTransformData('l3', copiedScope.l3, currentL3)
            };

            const sequence = ['countries', 'businessUnits', 'projectClients', 'projects', 'sites', 'l3'];
            for (const field of sequence) {
                if (validScopes[field].length > 0) {
                    handleItemSelect(menuId, field, validScopes[field]);
                }
            }

            message.success("Scope Pasted Successfully");
        } catch (error) {
            console.error('Error pasting scope:', error);
            message.error("Error pasting scope");
        }
    };

    return (
        <div className="d-flex gap-2 mb-3">
            <Button
                color="primary"
                className="d-flex align-items-center gap-2"
                onClick={copyScope}
                size="sm"
            >
                <FaCopy className="w-4 h-4" />
                Copy Scope
            </Button>
            <Button
                color={copiedScope ? "success" : "secondary"}
                className="d-flex align-items-center gap-2"
                onClick={pasteScope}
                size="sm"
                disabled={!copiedScope}
            >
                <FaPaste className="w-4 h-4" />
                Paste Scope
            </Button>
            <Button
                color="danger"
                className="d-flex align-items-center gap-2"
                onClick={clearScope}
                size="sm"
                disabled={!copiedScope}
            >
                <FaTrash className="w-4 h-4" />
                Clear Scope
            </Button>
        </div>
    );
};

export const logFormData = (formData) => {
    // console.log("--- FormData Contents ---");

    // Store entries for better readability
    const entries = {};

    for (let [key, value] of formData.entries()) {
        // Check if it's a File object
        if (value instanceof File || value instanceof Blob) {
            entries[key] = {
                type: 'File',
                name: value.name,
                size: `${(value.size / 1024).toFixed(2)} KB`,
                contentType: value.type
            };
        }
        // Handle JSON strings
        else if (typeof value === 'string' && (value.startsWith('{') || value.startsWith('['))) {
            try {
                const parsed = JSON.parse(value);
                entries[key] = {
                    type: 'JSON',
                    value: parsed
                };
            } catch {
                entries[key] = value;
            }
        }
        // Handle regular values
        else {
            entries[key] = value;
        }
    }

    // console.log(entries);
    // console.log("--- End FormData ---");

    return formData; // Return formData for chaining
};


//RESULT MODEL IS PASTED FROM COMPETENCY DO NO UNCOMMENT IT

/*
const ResultModal = ({isOpen, toggle, examData}) => {
    const [selectedExamIndex, setSelectedExamIndex] = useState(0);

    if (!examData || examData.length === 0) {
        return null;
    }

    const renderDateList = () => {
        // console.log('ResultModal: Rendering date list');
        return (
            <Card className="mb-3">
                <CardBody>
                    <h5 className="mb-3">Exam Dates</h5>
                    {examData.map((exam, index) => {
                        return (
                            <Button
                                key={exam.id}
                                color={index === selectedExamIndex ? "primary" : "secondary"}
                                className="mb-2 d-flex align-items-center"
                                onClick={() => {
                                    setSelectedExamIndex(index);
                                }}
                            >
                                <CalendarOutlined className="mr-2"/>
                                {new Date(exam.createdAt).toLocaleDateString()}
                            </Button>
                        );
                    })}
                </CardBody>
            </Card>
        );
    };

    const renderQuestionNavigator = () => {
        const currentExam = examData[selectedExamIndex];
        return (
            <Card className="mb-3">
                <CardBody>
                    <h5 className="mb-3">Question Navigator</h5>
                    <div className="d-flex flex-wrap">
                        {currentExam.quiz.map((question, index) => {
                            return (
                                <Button
                                    key={index}
                                    color={
                                        question.answer === question.myAnswer ? "success" : "danger"
                                    }
                                    className="m-1"
                                >
                                    {index + 1}
                                </Button>
                            );
                        })}
                    </div>
                </CardBody>
            </Card>
        );
    };

    const renderExamSummary = () => {
        const currentExam = examData[selectedExamIndex];
        return (
            <Card>
                <CardBody>
                    <h5 className="mb-3">Exam Summary</h5>
                    <p>Total Questions: {currentExam.totalMarks}</p>
                    <p>Correct Answers: {currentExam.myMarks}</p>
                    <p>
                        Score:{" "}
                        {((currentExam.myMarks / currentExam.totalMarks) * 100).toFixed(2)}%
                    </p>
                </CardBody>
            </Card>
        );
    };

    const renderQuestions = () => {
        const currentExam = examData[selectedExamIndex];
        return currentExam.quiz.map((question, index) => {
            return (
                <Card key={index} className="mb-3">
                    <CardBody>
                        <h5 className="mb-3">Question {index + 1}</h5>
                        <p>{question.question}</p>
                        {["A", "B", "C", "D"].map((option) => (
                            <div
                                key={option}
                                className={`mb-2 ${question.myAnswer === option ? "font-weight-bold" : ""}`}
                            >
                                {option}: {question[option]}
                                {question.myAnswer === option && question.answer !== option && (
                                    <CloseCircleFilled className="ml-2 text-danger"/>
                                )}
                                {question.answer === option && (
                                    <CheckCircleFilled className="ml-2 text-success"/>
                                )}
                            </div>
                        ))}
                    </CardBody>
                </Card>
            );
        });
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="xl" fullscreen={true}>
            <ModalHeader toggle={toggle}>Exam Results</ModalHeader>
            <ModalBody>
                <Row>
                    <Col md={3}>
                        {renderDateList()}
                        {renderQuestionNavigator()}
                        {renderExamSummary()}
                    </Col>
                    <Col md={9}>{renderQuestions()}</Col>
                </Row>
            </ModalBody>
        </Modal>
    );
};*/


export const SuspenseModalComponent = ({ isOpen, toggle, SelectedComponent, title, access }) => {
    // Modal loading fallback
    const ModalFallback = () => (
        <div className="text-center p-4">
            <Spinner color="primary">
                Loading...
            </Spinner>
            <div className="mt-2">Loading module...</div>
        </div>
    );



    return (
        <Modal isOpen={isOpen} toggle={toggle} size="xl">
            <ModalHeader toggle={toggle}>{title}</ModalHeader>
            <ModalBody>
                {SelectedComponent && (
                    <Suspense fallback={<ModalFallback />}>
                        <SelectedComponent access={access} />
                    </Suspense>
                )}
            </ModalBody>
        </Modal>
    );
};


export const SlipperyIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="50.000000pt" height="50.000000pt"
         viewBox="0 0 1920.000000 1676.000000" preserveAspectRatio="xMidYMid meet">

        <g transform="translate(0.000000,1676.000000) scale(0.100000,-0.100000)" fill="#FFBF00" stroke="none">
            <path
                d="M9444 16736 c-88 -32 -146 -69 -195 -124 -24 -27 -111 -166 -193 -308 -83 -142 -213 -369 -291 -504 -78 -135 -184 -319 -237 -410 -206 -357 -817 -1415 -918 -1590 -133 -230 -363 -630 -545 -945 -299 -517 -433 -751 -583 -1010 -350 -607 -445 -770 -571 -990 -126 -217 -260 -450 -586 -1015 -78 -135 -204 -353 -280 -485 -310 -537 -620 -1073 -840 -1455 -78 -135 -204 -353 -280 -485 -76 -132 -202 -350 -280 -485 -78 -135 -204 -353 -280 -485 -76 -132 -202 -350 -280 -485 -78 -135 -204 -353 -280 -485 -76 -132 -202 -350 -280 -485 -78 -135 -213 -369 -300 -520 -87 -151 -223 -387 -303 -525 -259 -450 -407 -706 -554 -960 -146 -252 -360 -625 -583 -1010 -67 -115 -191 -331 -277 -480 -532 -923 -504 -868 -507 -1000 -5 -227 132 -415 348 -481 69 -21 18433 -21 18502 0 160 49 286 174 333 331 19 61 19 190 1 260 -19 70 -30 92 -255 480 -254 439 -375 649 -541 938 -82 141 -216 373 -298 515 -146 253 -357 619 -391 677 -20 35 -274 475 -300 520 -9 17 -77 134 -150 260 -73 127 -201 347 -283 490 -209 363 -424 735 -557 965 -62 107 -120 209 -130 225 -19 34 -307 532 -473 820 -145 252 -126 219 -277 480 -73 127 -190 329 -260 450 -70 121 -205 355 -300 520 -95 165 -230 399 -300 520 -70 121 -187 324 -260 450 -73 127 -199 345 -280 485 -81 140 -205 356 -277 480 -71 124 -200 347 -285 495 -86 149 -212 367 -280 485 -69 118 -196 339 -283 490 -87 151 -224 388 -303 525 -80 138 -211 365 -292 505 -81 140 -208 361 -282 490 -75 129 -201 348 -280 485 -80 138 -206 356 -280 485 -288 498 -395 684 -546 945 -86 149 -221 383 -300 520 -235 407 -447 775 -588 1020 -76 131 -154 254 -182 286 -52 57 -135 109 -217 133 -73 23 -219 18 -291 -8z m265 -236 c21 -10 50 -32 67 -49 16 -16 189 -308 386 -648 603 -1046 2557 -4431 4763 -8253 824 -1427 1758 -3045 2075 -3595 318 -550 831 -1439 1140 -1975 830 -1437 818 -1416 825 -1465 16 -102 -42 -207 -145 -261 -34 -19 -281 -19 -9220 -19 l-9185 0 -40 22 c-107 58 -164 179 -132 284 8 25 236 430 507 900 271 469 584 1012 695 1204 304 527 883 1530 1195 2070 378 655 1409 2442 1590 2755 81 140 239 415 352 610 679 1177 969 1678 1423 2465 279 484 861 1492 1293 2240 1048 1815 1674 2900 1904 3300 191 330 227 383 283 413 69 36 157 37 224 2z"/>
            <path
                d="M9563 15959 c-18 -5 -43 -24 -56 -42 -13 -17 -146 -250 -294 -517 -149 -267 -411 -737 -583 -1045 -172 -308 -431 -771 -575 -1030 -144 -258 -542 -972 -885 -1585 -342 -613 -741 -1326 -885 -1585 -268 -481 -1437 -2575 -2253 -4035 -250 -448 -658 -1179 -907 -1625 -249 -445 -550 -985 -670 -1200 -120 -214 -336 -601 -480 -860 -144 -258 -392 -702 -550 -985 -158 -283 -303 -542 -321 -576 -21 -37 -34 -75 -34 -96 0 -43 31 -85 76 -104 50 -21 16858 -21 16908 0 18 7 42 26 54 41 33 41 28 88 -17 170 -21 39 -438 785 -926 1660 -878 1572 -1839 3293 -2250 4030 -592 1060 -2512 4500 -2825 5060 -197 352 -606 1086 -910 1630 -884 1584 -1225 2195 -1359 2434 -146 259 -171 284 -258 260z m443 -1074 c218 -390 665 -1191 994 -1780 651 -1166 1202 -2153 1538 -2755 340 -609 700 -1255 1242 -2225 277 -495 568 -1017 648 -1160 136 -245 673 -1207 932 -1670 237 -425 566 -1014 1365 -2445 450 -806 878 -1573 952 -1704 73 -131 132 -241 130 -242 -2 -2 -3697 -3 -8210 -2 l-8206 3 482 865 c266 476 692 1239 947 1695 254 457 656 1177 893 1600 236 424 580 1040 765 1370 184 330 399 715 477 855 79 140 293 525 478 855 184 330 711 1275 1172 2100 461 825 913 1635 1005 1800 92 165 362 649 600 1075 238 426 508 910 600 1075 92 165 252 451 355 635 103 184 241 433 308 553 67 119 125 216 129 215 4 -2 186 -322 404 -713z"/>
            <path
                d="M8128 10995 c-187 -35 -365 -131 -503 -270 -254 -253 -346 -628 -238 -969 99 -314 333 -543 658 -642 83 -26 103 -28 260 -28 143 0 182 4 248 22 366 101 637 396 708 769 20 105 7 330 -25 436 -51 171 -132 303 -262 427 -129 122 -236 184 -411 236 -111 33 -315 42 -435 19z"/>
            <path
                d="M8735 8923 c-115 -19 -516 -95 -567 -108 -148 -37 -256 -105 -858 -535 -316 -226 -613 -439 -659 -473 -138 -102 -234 -236 -280 -392 -11 -38 -62 -360 -112 -715 -86 -608 -90 -649 -80 -715 37 -230 229 -395 461 -395 209 0 388 133 444 330 9 30 52 309 97 620 48 338 85 568 92 572 7 3 176 113 376 243 200 130 367 232 371 228 4 -4 26 -84 48 -178 143 -596 475 -1937 488 -1969 38 -97 129 -192 229 -241 63 -31 176 -55 1210 -260 l1140 -226 28 -33 c15 -18 273 -372 573 -787 569 -788 620 -851 726 -903 210 -103 449 -64 614 99 102 101 154 228 154 374 -1 103 -12 158 -49 231 -15 30 -207 330 -426 665 -219 336 -461 707 -538 825 -173 266 -227 334 -330 416 -108 85 -181 119 -446 209 -123 41 -226 77 -228 79 -2 2 33 15 77 29 l81 25 607 -179 c334 -99 783 -232 997 -297 l390 -116 111 -1 c107 0 112 1 185 37 226 112 319 371 213 594 -35 74 -120 164 -191 201 -32 17 -227 83 -433 148 -206 64 -667 209 -1025 322 -357 112 -681 211 -720 220 -87 19 -308 22 -390 4 -33 -7 -126 -30 -206 -52 -81 -21 -151 -39 -155 -39 -5 0 11 10 36 22 25 12 251 177 503 365 493 370 518 392 568 521 19 48 23 76 23 172 0 130 -15 182 -82 276 -141 197 -402 261 -616 152 -32 -16 -397 -281 -683 -495 l-72 -54 -482 358 -482 358 -46 90 c-36 72 -62 107 -130 175 -93 93 -174 142 -293 178 -67 21 -208 34 -263 25z m1306 -2034 c223 -129 303 -157 454 -160 39 -1 61 -3 50 -6 -11 -3 -144 -38 -295 -78 -151 -41 -276 -72 -279 -70 -4 5 -111 395 -111 408 0 10 12 3 181 -94z"/>
            <path
                d="M13960 4074 c-43 -19 -77 -50 -98 -89 -38 -73 -352 -832 -352 -851 0 -28 30 -54 62 -54 21 0 77 61 331 361 267 315 307 367 317 409 36 151 -119 285 -260 224z"/>
            <path
                d="M11075 3588 c-160 -56 -181 -277 -33 -354 53 -27 847 -334 866 -334 28 0 54 34 50 66 -2 23 -63 76 -366 320 -405 324 -423 335 -517 302z"/>
            <path
                d="M14505 3103 c-11 -2 -212 -50 -447 -107 -288 -69 -434 -109 -448 -121 -25 -22 -25 -46 -2 -75 17 -21 35 -23 477 -53 265 -17 476 -27 498 -23 49 9 122 75 138 123 28 85 -14 194 -89 231 -40 21 -95 32 -127 25z"/>
            <path
                d="M7316 2609 c-162 -27 -304 -170 -336 -339 -13 -68 -13 -222 0 -290 29 -154 143 -281 289 -324 49 -14 388 -16 3577 -16 3497 0 3522 0 3585 20 114 36 214 131 260 247 20 51 23 76 23 218 1 151 0 164 -25 223 -49 116 -125 192 -241 241 l-63 26 -3510 1 c-1930 1 -3532 -2 -3559 -7z"/>
        </g>
    </svg>
);

export const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
};